import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import * as Styled from "./graph-animation-info-box.style";
import { selectors, useAppSelector } from "store";
import { useChartTimeline, } from "ui/components/elements/chart/chart-timeline";
import { partSecuredColor, energySavingColor, } from "store/system-performance/types";
import { vacuumPumpIdPrefix } from "ui/components/panels/graphs/constants";
import { useCurrentVacuumLevel, useIsAtAtmosphere, } from "hooks/graph-panel/use-current-vacuum-level";
export var GraphAnimationInfoBox = function () {
    var timeline = useChartTimeline();
    if (!timeline)
        return null;
    return _jsx(GraphAnimationInfoBoxContent, { timeline: timeline });
};
var GraphAnimationInfoBoxContent = function (_a) {
    var _b, _c, _d, _e;
    var timeline = _a.timeline;
    var parsedGraphData = useAppSelector(selectors.selectParsedGraphData);
    var graphData = useAppSelector(selectors.selectGraphData);
    var currentVacuumLevel = useCurrentVacuumLevel();
    // ATM is on at the start (before vacuum builds) and again once the part is
    // released. The return edge is glued to the cup-release event so it matches
    // the ATM reference line on the charts; tracking the governing pump instead
    // lit it ~0.02s early, since the pump reaches blow-off overpressure before the
    // cups release the part. See useIsAtAtmosphere.
    var isAboveAtm = useIsAtAtmosphere();
    var hasES = timeline.delayToEnergySave !== undefined;
    var reachedPS = false;
    var reachedES = false;
    if (currentVacuumLevel !== undefined && parsedGraphData && graphData) {
        var nodeData = parsedGraphData.nodeData;
        var _f = graphData.systemProperty, psIndex = _f.psIndex, esIndex = _f.esIndex;
        var pumpKey = vacuumPumpIdPrefix + graphData.governingPump.id;
        // nodeData[psIndex + 1] / [esIndex + 1] because index 0 is the padded entry
        // Small tolerance since the vacuumLevel only get close to ES
        // psIndex / esIndex can be -1 when the API did not identify the event (e.g.
        // zero transfer time). Guard against this to avoid accidentally indexing
        // nodeData[0] (the padded atmospheric entry) and treating 0 as a threshold.
        var THRESHOLD_TOLERANCE = 0.1;
        if (psIndex >= 0) {
            var psThreshold = (_c = (_b = nodeData[psIndex + 1]) === null || _b === void 0 ? void 0 : _b[pumpKey]) !== null && _c !== void 0 ? _c : 0;
            reachedPS =
                currentVacuumLevel !== 0 &&
                    currentVacuumLevel <= psThreshold + THRESHOLD_TOLERANCE;
        }
        if (hasES && esIndex >= 0) {
            var esThreshold = (_e = (_d = nodeData[esIndex + 1]) === null || _d === void 0 ? void 0 : _d[pumpKey]) !== null && _e !== void 0 ? _e : 0;
            reachedES =
                currentVacuumLevel !== 0 &&
                    currentVacuumLevel <= esThreshold + THRESHOLD_TOLERANCE;
        }
    }
    return (_jsxs(Styled.Indicators, { children: [_jsx(Styled.Indicator, { color: partSecuredColor, active: reachedPS, children: "PS" }), hasES && (_jsx(Styled.Indicator, { color: energySavingColor, active: reachedES, children: "ES" })), _jsx(Styled.Indicator, { color: "#27AE60", active: isAboveAtm, children: "ATM" })] }));
};
